export function isGridSkyVisibilityShortcut(event) {
  if (!event || !event.altKey) {
    return false;
  }

  return event.code === "KeyS" || event.keyCode === 83 || event.which === 83;
}
